import React, { useState } from "react";
import { withStyles } from "@material-ui/styles";
import TextField from "../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../ui/DataSelect";
import Grid from "@material-ui/core/Grid";

const defaultData = {
  code: "",
  name: "",
  group: 1,
  parentId: null
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  }
});

const InventGroupList = [
  { id: 1, name: "Оборудование" },
  { id: 2, name: "Инструмент" },
  { id: 3, name: "ПО" },
];

const AddInventTypeForm = ({
  disabled,
  onFormChange,
  initialData,
  classes,
  inventTypesList
}) => {
  const formdata = initialData ? initialData : defaultData;
  const [data, setData] = useState(formdata);
  const { code, name, parentId, group } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
          <Grid item xs={8}>
            <DataSelect
              value={group}
              onChange={value => onChange("group", value.id)}
              label="Группа"
              dataSource={InventGroupList}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              value={code}
              onChange={e => onChange("code", e.target.value)}
              label="Код"
              disabled={disabled}
            />
          </Grid>
      </Grid>
      <TextField
        value={name}
        onChange={e => onChange("name", e.target.value)}
        label="Наименование"
        disabled={disabled}
      />
      {inventTypesList &&
      <DataSelect
        value={parentId}
        onChange={value => onChange("parentId", value.id)}
        label="Родительский тип"
        dataSource={inventTypesList}
        disabled={disabled}
      />}
    </div>
  );
};

export default withStyles(styles)(AddInventTypeForm);
